import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import isoWeek from 'dayjs/plugin/isoWeek'; // Import any necessary plugins
import advancedFormat from 'dayjs/plugin/advancedFormat'; // For advanced formatting options

dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

export function formatDate(date: string | Date): string {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

export const StyledDescription = styled.dd`
  margin: 0px;
`;

export function formatDescription(
  desc: null | { [key: string]: string }
): string | React.ReactElement {
  if (desc == null) {
    return '';
  }

  return (
    <dl>
      {Object.keys(desc).map((key) => (
        <React.Fragment key={key}>
          <dt>
            <b>{key}:</b>
          </dt>
          <StyledDescription>{desc[key]}</StyledDescription>
        </React.Fragment>
      ))}
    </dl>
  );
}
